import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';
import cx from 'classnames';
import styles from "./CheckboxField.module.css";
import { Icon } from '../../Icon/Icon';
export const Checkbox = ({
  id,
  checked,
  label,
  required,
  controlClassName,
  hideLabel,
  showInlineLabel,
  onClick,
  onChange,
  onBlur,
  onFocus,
  onKeyDown,
  disabled,
  accessibilityProps,
  dataPathProps,
  renderInlineLabel,
  children,
  detailElement,
  value
}) => {
  const translator = useContext(TranslatorContext);
  const tabIndex = disabled ? undefined : 0;
  const checkboxElementClasses = cx(styles.checkboxElement);
  const checkboxElement = React.createElement("span", {
    onClick: onClick,
    className: checkboxElementClasses,
    "aria-label": translator(label),
    tabIndex: tabIndex,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    role: "checkbox",
    "aria-checked": checked
  }, checked && React.createElement(Icon, {
    icon: "mi-check",
    className: styles.checkboxIcon,
    "aria-hidden": "true"
  }));
  const detailVisible = checked && (children || detailElement);
  const detail = React.createElement("div", {
    className: cx({
      [styles.detailVisible]: detailVisible
    }),
    role: "region",
    "aria-live": "assertive",
    "aria-hidden": !detailVisible
  }, detailVisible && (children || detailElement));
  const classes = cx(styles.checkbox, controlClassName, {
    disabled
  });
  return React.createElement(React.Fragment, null, React.createElement("div", _extends({
    className: classes
  }, accessibilityProps), React.createElement("input", _extends({
    id: id,
    type: "checkbox",
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    className: styles.input,
    required: required
  }, dataPathProps)), checkboxElement, !hideLabel && showInlineLabel && renderInlineLabel(styles)), detail);
};
Checkbox.__docgenInfo = {
  componentName: "Checkbox",
  packageName: "@jutro/components",
  description: "",
  displayName: "Checkbox",
  methods: [],
  actualName: "Checkbox"
};